<template>
    <component :is="componentTag" />
</template>
<script>
import webFormNav from './web';
import mobileFormNav from './mobile';
export default {
    components: {
        webFormNav,
        mobileFormNav
    },
    data() {
        return {
            isMobile: false,
            componentTag: ''
        }
    },
    created() {
        this.listenObserverWidth(750);
    },

    methods: {
        // 监听可视窗口宽度
        listenObserverWidth(mobileWidth) {
           const resizeObserver = new ResizeObserver(entries => {
               for(let entry of entries) {
                  if(entry.contentRect.width <= mobileWidth) {
                      this.isMobile = true;
                      this.componentTag = 'mobileFormNav';
                  } else {
                      this.isMobile = false;
                      this.componentTag = 'webFormNav';
                  }
               }
           });
           resizeObserver.observe(document.body);
        },
    }
}
</script>
